module.exports = __webpack_public_path__ + "img/star-04.d9abfa58.svg";